'use client';

import { c as _c } from "react/compiler-runtime";
import { Chip } from '@module/mdrt-org/shared/components/chip/chip';
import { ChipTheme } from '@shared/ui-components/chip/chipTheme';
import { type CompanyAdminSectionContent } from '../hero-section-wrapper-server';
import styles from './hero-section-company-admin.module.scss';
export const HeroSectionCompanyAdmin = t0 => {
  const $ = _c(8);
  const {
    cmsContent,
    showCompanyAdminSection
  } = t0;
  if (!showCompanyAdminSection) {
    return null;
  }
  let t1;
  if ($[0] !== cmsContent.companyAdminSectionDescriptionLabel) {
    t1 = <p className={styles["hero-section-company-admin__description"]}>{cmsContent.companyAdminSectionDescriptionLabel}</p>;
    $[0] = cmsContent.companyAdminSectionDescriptionLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== cmsContent.companyAdminButtonLabel || $[3] !== cmsContent.companyAdminDashboardPagePath) {
    t2 = <Chip className={styles["hero-section-company-admin__action"]} isSmall={true} label={cmsContent.companyAdminButtonLabel} theme={ChipTheme.Emphasis} to={cmsContent.companyAdminDashboardPagePath} />;
    $[2] = cmsContent.companyAdminButtonLabel;
    $[3] = cmsContent.companyAdminDashboardPagePath;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className={styles["hero-section-company-admin"]}>{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};